<script setup>
import { computed } from 'vue';
import { useToggle } from '@vueuse/core';

import WidgetCustomizationSectionHeader from './WidgetCustomizationSectionHeader.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: true,
  },
  open: {
    type: Boolean,
    default: undefined,
  },
});

const emit = defineEmits(['toggle']);

const [internalOpen, toggleInternal] = useToggle(props.defaultOpen);

const isControlled = computed(() => props.open !== undefined);

const isOpen = computed(() =>
  isControlled.value ? props.open : internalOpen.value
);

const onToggle = () => {
  if (isControlled.value) {
    emit('toggle');
    return;
  }
  toggleInternal();
};
</script>

<template>
  <section v-bind="$attrs" class="mb-5 last:mb-0">
    <WidgetCustomizationSectionHeader
      :title="title"
      :open="isOpen"
      @toggle="onToggle"
    />
    <div
      v-if="isOpen"
      class="mb-2 grid w-full grid-cols-[auto_1fr] items-start gap-x-2.5 pt-1"
    >
      <span class="size-6 shrink-0" aria-hidden="true" />
      <div class="min-w-0 space-y-4">
        <slot />
      </div>
    </div>
  </section>
</template>
